export var SubscriptionBillingPeriod;
(function(SubscriptionBillingPeriod) {
    SubscriptionBillingPeriod[SubscriptionBillingPeriod["OneMonth"] = 1] = "OneMonth";
    SubscriptionBillingPeriod[SubscriptionBillingPeriod["TwoMonths"] = 2] = "TwoMonths";
    SubscriptionBillingPeriod[SubscriptionBillingPeriod["ThreeMonths"] = 3] = "ThreeMonths";
    SubscriptionBillingPeriod[SubscriptionBillingPeriod["FourMonths"] = 4] = "FourMonths";
    SubscriptionBillingPeriod[SubscriptionBillingPeriod["SixMonths"] = 6] = "SixMonths";
    SubscriptionBillingPeriod[SubscriptionBillingPeriod["TwelveMonths"] = 12] = "TwelveMonths";
})(SubscriptionBillingPeriod || (SubscriptionBillingPeriod = {}));

//# sourceMappingURL=subscription-billing-period.js.map